import React, { useMemo } from 'react';
import { Flex } from 'antd';
import { TotalTitle, StrongTotal, GridTotales } from './styles';
import { moneyFormat } from 'utils/TextFormattingUtils';
import { numeroALetras } from 'utils/funcionesUtiles';

const Totales = ({ detalles = [], documento }) => {
  const totalBruto = useMemo(() => {
    return detalles.reduce((total, { cantidad, precioUnitario, valorTotalDescuento }) => {
      return total + (cantidad * precioUnitario - valorTotalDescuento);
    }, 0);
  }, [detalles]);

  const totalIva = useMemo(() => {
    return detalles.reduce((total, { porcentajeIva, cantidad, precioUnitario }) => {
      return total + (porcentajeIva * (cantidad * precioUnitario)) / 100;
    }, 0);
  }, [detalles]);

  const totalConsumo = useMemo(() => {
    return detalles.reduce((total, { ico = 0, cantidad, precioUnitario }) => {
      return total + (ico * (cantidad * precioUnitario)) / 100;
    }, 0);
  }, [detalles]);

  const totalPagar = useMemo(
    () => totalBruto + totalIva + totalConsumo,
    [totalBruto, totalIva, totalConsumo],
  );

  const valorLetras = useMemo(() => numeroALetras(totalPagar), [detalles]);

  const totalReteIca = useMemo(
    () => (documento.dsRetencionIca * totalBruto) / 100,
    [documento.dsRetencionIca, totalBruto],
  );

  return (
    <Flex vertical align='end' style={{ margin: '30px 0px' }}>
      <GridTotales>
        <TotalTitle>
          Rete Fuente: <StrongTotal>{moneyFormat(documento.dsRetencionFuente)}</StrongTotal>
        </TotalTitle>
        <TotalTitle>
          Rete ICA: <StrongTotal>{moneyFormat(totalReteIca)}</StrongTotal>
        </TotalTitle>
        <TotalTitle>
          Descuento: <StrongTotal>{moneyFormat(documento.descuentoTotal)}</StrongTotal>
        </TotalTitle>
        <TotalTitle>
          Total Bruto: <StrongTotal>{moneyFormat(totalBruto)}</StrongTotal>
        </TotalTitle>
        <TotalTitle>
          Total IVA: <StrongTotal>{moneyFormat(totalIva)}</StrongTotal>
        </TotalTitle>
        <TotalTitle>
          Rete IVA: <StrongTotal>{moneyFormat(documento.dsRetencionIva)}</StrongTotal>
        </TotalTitle>
        <TotalTitle>
          Total INC: <StrongTotal>{moneyFormat(totalConsumo)}</StrongTotal>
        </TotalTitle>
        <TotalTitle>
          Total a Pagar: <StrongTotal>{moneyFormat(totalPagar)}</StrongTotal>
        </TotalTitle>
        <TotalTitle style={{ gridArea: 'letras' }}>
          Total en letras: <StrongTotal>{valorLetras}</StrongTotal>
        </TotalTitle>
      </GridTotales>
    </Flex>
  );
};

export default Totales;
